<section class="container-fluild">
    <div class="login-container">
        <h1 class="login-title">{{'login.sign_in' | translate}}</h1>
        
        <img class="image-corner" [src]="asset('assets/images/banner.png')" alt="corner" />
    </div>
</section>